import { Link } from 'react-router-dom';
import { mangas } from '@/mocks/manga';

export default function LatestUpdates() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16" aria-label="最新更新">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <span className="text-xs font-medium uppercase tracking-widest text-primary-600">
            Latest
          </span>
          <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">最近更新</h2>
        </div>
        <Link
          to="/category"
          className="flex items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
        >
          更多更新
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      </div>

      <div className="mt-6 flex gap-4 overflow-x-auto pb-2">
        {mangas.map((manga) => (
          <Link
            key={manga.id}
            to={`/manga/${manga.id}`}
            className="group flex w-72 shrink-0 items-center gap-3 rounded-lg bg-background-100 p-3 transition-colors hover:bg-background-200/70"
          >
            <span className="relative h-28 w-20 shrink-0 overflow-hidden rounded-md bg-background-50">
              <img
                src={manga.cover}
                alt={`${manga.title}漫画最新更新`}
                title={`${manga.title}漫画免费阅读`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                {manga.title}
              </span>
              <span className="mt-1.5 flex items-center gap-1 text-xs text-primary-700">
                <i className="ri-arrow-right-up-line" aria-hidden="true" />
                <span className="truncate">{manga.latestChapter}</span>
              </span>
              <span className="mt-1 flex items-center gap-2 text-xs text-foreground-600">
                <span className="truncate">{manga.author}</span>
                <span className="whitespace-nowrap">{manga.updateTime}</span>
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}